var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiLikePlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "emoji-like_placeholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Navigation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XX---UI-elements-(buttons,-tabs,-etc)",
    transform: "translate(-355.000000, -1546.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(69.500000, 798.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "emoji-like_placeholder",
    transform: "translate(285.500000, 748.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9997838,1.687539e-13 C24.8221622,1.687539e-13 31.9995676,7.17751351 31.9995676,15.9997838 C31.9995676,24.8220541 24.8220541,31.9995676 15.9997838,31.9995676 C7.17751351,31.9995676 -2.85993451e-13,24.8220541 -2.85993451e-13,15.9997838 C-2.85993451e-13,7.17751351 7.17751351,1.687539e-13 15.9997838,1.687539e-13 Z",
    id: "Combined-Shape",
    fill: "#B9BDC4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.000000, 5.500000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1072,1.56725926 C11.5232,-0.237370852 14.3936,0.0870570338 14.1856,2.05390109 C13.9776,4.08157538 13.5616,4.75070789 13.2496,6.71755195 C13.208,6.9811496 13.3952,7.20419377 13.6656,7.20419377 L13.6656,7.20419377 L18.304,7.20419377 C19.0944,7.20419377 19.76,7.85304955 19.76,8.62356577 C19.76,9.394082 19.1152,10.0429378 18.304,10.0429378 L18.304,10.0429378 L18.0752,10.0429378 C18.928,10.0429378 19.6352,10.7931773 19.4896,11.6853539 C19.4064,12.4153167 18.7408,12.9222353 17.992,12.9222353 L17.992,12.9222353 L17.8256,12.9222353 C18.6992,12.9222353 19.4064,13.6724747 19.2816,14.5443747 C19.1984,15.2743374 18.5328,15.781256 17.784,15.781256 L17.784,15.781256 L17.5968,15.781256 C18.3872,15.781256 19.0528,16.409835 19.0528,17.200628 C19.0528,17.9711442 18.408,18.62 17.5968,18.62 L17.5968,18.62 L12.2512,18.62 C8.84,18.62 7.6752,17.6872698 6.656,17.2614582 C6.3856,17.1397978 6.1984,16.8762001 6.1984,16.5923257 L6.1984,16.5923257 L6.1984,8.48162857 C6.1984,8.23830766 6.3232,8.03554023 6.5104,7.89360303 C7.4672,7.22447052 10.3376,4.95347532 11.1072,1.56725926 Z M4.3264,8.07609372 C4.7424,8.07609372 5.0752,8.4005216 5.096,8.80605646 L5.096,8.80605646 L5.096,16.3287281 C5.096,16.7342629 4.7632,17.0586908 4.3472,17.0586908 L4.3472,17.0586908 L0.7488,17.0586908 C0.3328,17.0586908 0,16.7342629 0,16.3287281 L0,16.3287281 L0,8.80605646 C0,8.4005216 0.3328,8.07609372 0.7488,8.07609372 L0.7488,8.07609372 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiLikePlaceholder);
export default __webpack_public_path__ + "static/media/emoji-like_placeholder.529bbd2b7422738f4e28dd1bbd6b3595.svg";
export { ForwardRef as ReactComponent };